import { countries } from "@/constants/countries";
import { useRouter } from "next/router";
import { z } from "zod";
import { Form, useFormHook } from "./FormComps";
import Fieldset from "./ui/Fieldset";
import { useQueryClient } from "@tanstack/react-query";

const schema = z.object({
  phoneCountryCode: z.string().min(1, "This field is required!"),
  phone: z.string().regex(/^(\s*|\d+)$/, "must contain only digits"),
});

export default function AddPhoneForm({ userId }: { userId: string }) {
  const { locale } = useRouter();
  const queryClient = useQueryClient();

  const phoneCountryCodes = countries.map((country) => ({
    value: country.dial_code,
    label: `${country.emoji} ${country.name}`,
  }));

  const onSubmit = async (formValues) => {
    const patchPhoneNumberResponse = await fetch("/api/patch-phone-number", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId,
        phoneCountryCode: formValues.phoneCountryCode,
        phone: formValues.phone,
      }),
    });

    const patchPhoneNumberResult = await patchPhoneNumberResponse.json();

    if (!patchPhoneNumberResponse.ok) {
      console.error(patchPhoneNumberResult.error.message);
      return;
    }
    queryClient.invalidateQueries({ queryKey: ["userPhoneIntroMeeting-1"] });
  };

  const form = useFormHook({
    schema,
    onSubmit,
  });

  return (
    <>
      <Form form={form} onSubmit={onSubmit} hasSubmitButton={false}>
        <Fieldset
          name="phonenumber"
          legend={
            locale === "en" ? "Please enter your phone number first:" : "لطفاً ابتدا شماره تلفن خود را وارد کنید:"
          }
        >
          <div className={`flex gap-3 ${locale === "fa" ? "flex-row-reverse" : ""}`}>
            <Form.ReactSelect
              name="phoneCountryCode"
              label={locale === "en" ? "Country Code" : "کد کشور"}
              options={phoneCountryCodes}
              required
            />
            <div className="grow">
              <Form.Input name="phone" required label={locale === "en" ? "Number" : "شماره"} dir="ltr" />
            </div>
          </div>
        </Fieldset>
        <Form.SubmitButton width="parent" className="submit-intro-request-modal-button">
          {locale === "fa" ? "ثبت" : "Submit"}
        </Form.SubmitButton>
      </Form>
    </>
  );
}
